import { Box, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { CompanyInfoTableRowStyles } from "./CompanyManagement.styles";

interface CompanyTableRowProps {
  title: string;
  info: string | number;
  isEmail?: boolean;
}

const CompanyTableRow: FC<CompanyTableRowProps> = ({ title, info, isEmail }) => {
  return (
    <CompanyInfoTableRowStyles>
      <Box>
        <Typography>{title}</Typography>
      </Box>
      <Box>
        {!isEmail ? (
          <Typography>{info}</Typography>
        ) : (
          <Tooltip title={info}>
            <Typography
              noWrap
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                maxWidth: "100%",
                display: "block"
              }}
            >
              {info}
            </Typography>
          </Tooltip>
        )}
      </Box>
    </CompanyInfoTableRowStyles>
  );
};

export default CompanyTableRow;
